// Main entry point for Garden Viewer 3D

import { debug } from '@/utils/debug'
import { initApp } from './bootstrap'

// Start the application
initApp().catch((error) => {
  debug.error('App', 'Fatal error during initialization', error)
  console.error('Fatal error:', error)
})
